__turbopack_context__.v({
  "ant-form-item": "GbHhcW_ant-form-item",
  "ant-select-selector": "GbHhcW_ant-select-selector",
  "buttonSubmit": "GbHhcW_buttonSubmit",
  "card": "GbHhcW_card",
  "custom": "GbHhcW_custom",
  "customTabs": "GbHhcW_customTabs",
  "customtab": "GbHhcW_customtab",
  "form": "GbHhcW_form",
  "images": "GbHhcW_images",
  "infoimages": "GbHhcW_infoimages",
  "informasilabel": "GbHhcW_informasilabel",
  "informasilabel1": "GbHhcW_informasilabel1",
  "input": "GbHhcW_input",
  "inputCalendar": "GbHhcW_inputCalendar",
  "inputForm": "GbHhcW_inputForm",
  "question": "GbHhcW_question",
  "title": "GbHhcW_title",
  "titleContent": "GbHhcW_titleContent",
});
